module.exports = __webpack_public_path__ + "img/profile-original-150.c2f62b7e.jpg";